import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    background: #1a1a2e;
    color: #e0e0e0;
    font-family: 'Montserrat', sans-serif;
  }

  /* NAV */
  nav {
    background: #12122a;
    border-bottom: 2px solid #2a2a50;
    padding: 0 2rem;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .nav-logo {
    font-size: 1.15rem;
    font-weight: 800;
    color: #fff;
    letter-spacing: 0.05em;
    cursor: pointer;
    text-transform: uppercase;
  }

  .nav-links {
    display: flex;
    gap: 0.25rem;
    list-style: none;
  }

  .nav-links button {
    background: none;
    border: none;
    color: #aaaacc;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    padding: 0.45rem 0.9rem;
    border-radius: 5px;
    cursor: pointer;
    transition: color 0.18s, background 0.18s;
  }

  .nav-links button:hover,
  .nav-links button.active {
    color: #fff;
    background: rgba(255,255,255,0.07);
  }

  /* PAGE WRAPPER */
  .page {
    max-width: 960px;
    margin: 0 auto;
    padding: 3.5rem 1.5rem 5rem;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* SECTION TITLES */
  .section-title {
    text-align: center;
    font-size: 1.9rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 0.6rem;
  }

  .section-subtitle {
    text-align: center;
    color: #9999bb;
    font-size: 0.9rem;
    margin-bottom: 3rem;
    line-height: 1.6;
  }

  /* GAME SECTION */
  .game-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .game-name {
    font-size: 1.4rem;
    font-weight: 800;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .game-description {
    color: #aaaacc;
    font-size: 0.92rem;
    line-height: 1.75;
    text-align: center;
    max-width: 600px;
  }

  /* SCREENSHOTS */
  .screenshots {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0.5rem 0;
  }

  .screenshots img {
    width: 130px;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0,0,0,0.5);
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    display: block;
  }

  .screenshots img:hover {
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 14px 36px rgba(0,0,0,0.6);
  }

  /* DOWNLOAD */
  .download-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #9999bb;
    text-align: center;
  }

  .store-badges {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
  }

  .store-badges a img {
    height: 44px;
    display: block;
    transition: opacity 0.2s, transform 0.15s;
  }

  .store-badges a:hover img {
    opacity: 0.85;
    transform: scale(1.04);
  }

  /* LEGAL */
  .legal-box {
    background: #13132a;
    border: 1px solid #2a2a50;
    border-radius: 12px;
    padding: 2.5rem;
    max-width: 780px;
    margin: 0 auto;
    line-height: 1.8;
  }

  .legal-box h2 {
    color: #fff;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 2rem 0 0.5rem;
    border-bottom: 1px solid #2a2a50;
    padding-bottom: 0.4rem;
  }

  .legal-box h2:first-of-type { margin-top: 0; }

  .legal-box h3 {
    color: #ccccee;
    font-size: 0.82rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin: 1.2rem 0 0.4rem;
  }

  .legal-box p {
    color: #9999bb;
    font-size: 0.88rem;
    margin-bottom: 0.7rem;
  }

  .legal-box ul {
    padding-left: 1.4rem;
    color: #9999bb;
    font-size: 0.88rem;
    margin-bottom: 0.7rem;
  }

  .legal-box ul li { margin-bottom: 0.3rem; }

  .legal-box .effective {
    font-size: 0.8rem;
    color: #6666aa;
    margin-bottom: 1.5rem;
  }

  .coming-soon-box {
    text-align: center;
    padding: 4rem;
    color: #6666aa;
    font-size: 0.9rem;
    letter-spacing: 0.08em;
  }

  /* CONTACT */
  .contact-card {
    background: #13132a;
    border: 1px solid #2a2a50;
    border-radius: 12px;
    padding: 3rem 2rem;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
  }

  .contact-card h2 {
    font-size: 1rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #fff;
    margin-bottom: 1.5rem;
  }

  .contact-card p {
    color: #9999bb;
    font-size: 0.92rem;
    line-height: 2;
  }

  /* FOOTER */
  footer {
    text-align: center;
    padding: 1.8rem;
    color: #44446a;
    font-size: 0.75rem;
    letter-spacing: 0.07em;
    border-top: 1px solid #1e1e3a;
  }

  /* LIGHTBOX */
  .lightbox-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.88);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    cursor: pointer;
    animation: fadeIn 0.2s ease;
  }

  .lightbox-overlay img {
    max-height: 90vh;
    max-width: 90vw;
    border-radius: 14px;
    box-shadow: 0 20px 80px rgba(0,0,0,0.8);
  }
`;

const SCREENSHOTS = [
  "https://heroes-team.com/images/games/magic-jewels/1.webp",
  "https://heroes-team.com/images/games/magic-jewels/2.webp",
  "https://heroes-team.com/images/games/magic-jewels/3.webp",
  "https://heroes-team.com/images/games/magic-jewels/4.webp",
];

const APPSTORE_BADGE = "https://heroes-team.com/images/games/appstore.svg";

function OurGames() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <div className="page">
      <h1 className="section-title">Our Games</h1>
      <p className="section-subtitle">
        We love making games. And we hope you will enjoy<br />
        playing them as much as we enjoy developing them.
      </p>

      <div className="game-section">
        <div className="game-name">Magic Jewels Quest — Match 3</div>

        <p className="game-description">
          Thrilling surprises and breathtaking mystery adventure are waiting for you
          in this free jewelry game! A bejeweled classic journey is about to start!
          Unlock new levels, practice your skills and be a magic jewel master!
          Begin your jewel crush game for FREE and dive into jewel fever like in
          the newest match 3 games!
        </p>

        <div className="screenshots">
          {SCREENSHOTS.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Screenshot ${i + 1}`}
              onClick={() => setLightbox(src)}
            />
          ))}
        </div>

        <div className="download-label">Download</div>
        <div className="store-badges">
          <a
            href="https://apps.apple.com/il/app/magic-jewels-quest-match-3/id1514569342"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={APPSTORE_BADGE} alt="Download on the App Store" />
          </a>
        </div>
      </div>

      {lightbox && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <img src={lightbox} alt="Screenshot full" />
        </div>
      )}
    </div>
  );
}

function PrivacyPolicy() {
  return (
    <div className="page">
      <h1 className="section-title">Privacy Policy</h1>
      <p className="section-subtitle">Sasin Software Development</p>
      <div className="legal-box">
        <p className="effective">Effective Date: 20 May 2020</p>

        <h2>1. Who Is Responsible for Processing Your Data</h2>
        <p>This Privacy Policy applies to all of our games, websites and related services, collectively referred to here as our Services. Your continued use of the Services after the effective date will be subject to the new Privacy Policy.</p>
        <p>For the purpose of the General Data Protection Regulation 2016/679 and any implementing legislation (the "GDPR"), <strong>Sasin Software Development</strong> (referred to as "we", "us", or "our") will be the data controller responsible for any personal data we process.</p>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us through the game's Support.</p>
        <p><strong>The data controller:</strong> Sasin Software Development<br />
        <strong>Address:</strong> No 315, Monivong Blvd., Office 1849 Register 05, Phnom Penh, Cambodia</p>

        <h2>2. What Personal Data We Collect and Why</h2>
        <p>We may source, use and otherwise process your personal data in different ways. In all cases we are committed to protecting your personal data.</p>

        <h3>2.1 Individual Customers</h3>
        <h3>A – Sources of Personal Data</h3>
        <ul>
          <li>From you directly (through the game, website or online forms);</li>
          <li>From third parties and service providers assisting us, or from social network accounts you used to sign in.</li>
        </ul>

        <h3>B – Personal Data That We Collect and Process</h3>
        <ul>
          <li>Contact information (name, nickname, or email submitted during registration);</li>
          <li>Account and game progress data, including a unique ID created for you;</li>
          <li>IP address and unique mobile device identification numbers;</li>
          <li>Device data (manufacturer, OS, CPU, RAM, language);</li>
          <li>Broad location data (country or city level);</li>
          <li>Precise geolocation data (GPS, with your consent);</li>
          <li>Data received if you link a third-party tool (e.g. Facebook);</li>
          <li>Order details (amount spent, date, time, offers used);</li>
          <li>Fraud-prevention data;</li>
          <li>Platform data (to verify payment);</li>
          <li>Advertising and analytics data;</li>
          <li>Support messages and feedback; and/or</li>
          <li>Other data you choose to give us.</li>
        </ul>

        <h3>C – Why Do We Collect Your Personal Data?</h3>
        <p>We may use your personal data to: provide our products or services; manage our relationship with you; understand how our services are used; maintain security; and keep you informed about products and events.</p>
        <p>Our lawful bases are: <strong>Contract</strong> and <strong>Legitimate Interest</strong>.</p>
        <p>We do not knowingly collect personal data about anyone under the age of 16. If we learn we have collected such data, we will delete it as quickly as possible.</p>

        <h3>D – How Long Do We Keep Your Personal Data?</h3>
        <p>We will process your personal data only for as long as necessary for the purposes for which it was collected, unless a legal right or obligation requires longer retention.</p>

        <h3>2.2 Corporate Customers, Business Partners, and Vendors</h3>
        <p>We may collect name, business address, business email, telephone number, and job title from corporate contacts to manage business relationships.</p>

        <h2>3. Who Do We Share Your Personal Data With</h2>
        <p>We may share your information with: technical support providers; third-party software providers; professional advisers; advertising and promotional agencies; and service providers assisting in delivering our services.</p>
        <p>We may also disclose personal data to law enforcement or government bodies as permitted by law.</p>

        <h2>4. Transfers of Personal Data Outside the EU/EEA</h2>
        <p>International transfers are governed by EU Commission-approved Standard Contractual Clauses. You may request a copy of these agreements by contacting us.</p>

        <h2>5. Your Rights</h2>
        <p>You are entitled to access, amend, correct or delete your personal data held by us. You can also limit, restrict or object to the processing of your data. To exercise any of these rights, contact us using the details in section 1.</p>

        <h2>6. California Privacy Rights (CCPA)</h2>
        <p>California residents may request a list of third parties to whom we have disclosed their personal information during the prior calendar year. This request may be made once per year, free of charge.</p>

        <h2>7. Non-Discrimination</h2>
        <p>Users have the right to not receive discriminatory treatment for exercising their privacy rights under the CCPA and other applicable data privacy laws.</p>
      </div>
    </div>
  );
}

function TermsOfUse() {
  return (
    <div className="page">
      <h1 className="section-title">Terms of Use</h1>
      <p className="section-subtitle">Sasin Software Development</p>
      <div className="legal-box">
        <p className="effective">Last modified: 20 May 2020</p>

        <p>The terms of this agreement ("Terms of Use") govern the relationship between you and <strong>Sasin Software Development</strong> ("Sasin" or "Us" or "We") regarding your use of Sasin Software Development games, websites and related services (the "Service"). By using this website, downloading any software, or browsing the website, as well as by downloading any of our mobile games from app stores, you accept the following Terms of Use. If you do NOT agree to all these Terms of Use, please do NOT use this website and/or download any of our games.</p>
        <p>Sasin Software Development is authorized to amend the Terms of Use at any time, with the amended Terms of Use effective as soon as they are posted on this website. Sasin Software Development reserves the right to make changes to the website and its games at any time without notice, and to terminate or restrict access at its sole discretion.</p>

        <h2>Warranties and Disclaimers</h2>
        <p>ALL INFORMATION, SOFTWARE, AND SERVICES OFFERED ON THIS WEBSITE ARE PROVIDED "AS IS." SASIN SOFTWARE DEVELOPMENT HEREBY EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.</p>
        <p>SASIN SOFTWARE DEVELOPMENT MAKES NO WARRANTY AS TO THE CONTENT, ACCURACY, TIMELINESS, OR COMPLETENESS OF ITS INFORMATION, SOFTWARE, OR SERVICES, AND ASSUMES NO RESPONSIBILITY FOR ERRORS OR OMISSIONS. IN NO CASE SHALL SASIN SOFTWARE DEVELOPMENT BE HELD LIABLE FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, PUNITIVE, SPECIAL, OR INCIDENTAL DAMAGES ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF ITS INFORMATION.</p>
        <p>DOWNLOADING AND USING ANY SOFTWARE OR SERVICES OFFERED ON THE WEBSITE IS DONE AT YOUR OWN DISCRETION AND RISK. YOU ARE SOLELY RESPONSIBLE FOR ALL DAMAGE TO YOUR DEVICE, LOSS OF DATA, OR OTHER HARM THAT RESULTS FROM SUCH ACTIVITIES.</p>

        <h2>Copyright</h2>
        <p>Copyrights, trademarks, and all other proprietary rights in the content (including software, services, text, graphics, and logos) are reserved to Sasin Software Development and protected by international copyright laws. You agree not to copy, republish, modify, download, distribute, license, sublicense, reverse engineer, or create derivatives based on the site, its software, or its services except as expressly authorized herein.</p>
        <p>Content published on this website may be reproduced or distributed in unmodified form for personal, non-commercial use only. Any other use without prior written consent of Sasin Software Development is strictly prohibited.</p>

        <h2>In-Game Currencies and Goods</h2>
        <p>Our mobile games include virtual in-game currency ("Virtual Currency"), such as coins, cash, and/or crystals, that can be purchased for real money and used to purchase virtual in-game items ("Virtual Items"). All Virtual Currency transactions are handled by third-party e-commerce payment providers. By purchasing in-game Virtual Currency, you agree to the third-party payment providers' Terms of Use.</p>
        <p>Virtual Currency or Virtual Items cannot be exchanged for real money, goods, or services of monetary value. Transferring Virtual Currency or Virtual Items outside the Games is strictly prohibited. All prices and sales of Virtual Currency and Virtual Items are final. You only purchase a limited, revocable, non-transferable license to use in-game Virtual Currency or Virtual Items — you do not own them.</p>
        <p>In the event your account is terminated or if Sasin Software Development discontinues its Games, you forfeit any and all Virtual Currency and Virtual Items earned or purchased.</p>

        <h2>Refunds</h2>
        <p>If you give your account or payment details to someone else, appear to be abusing our policies, or don't protect your account with authentication, we usually cannot issue a refund. Payment processor's standard terms and conditions regarding refunds will apply. Refunds are exclusive of taxes previously charged for product purchases.</p>

        <h3>Special Refund Regulation for Google Play</h3>
        <p>If a purchase isn't what you expected, doesn't work, or you no longer want it, you may request a refund on the Google Play website within 48 hours of purchase, or contact Sasin Software Development directly. Refund requests more than 30 calendar days after purchase are not eligible. Each request is subject to investigation and will be granted if found acceptable under these Terms of Use.</p>

        <h3>Special Refund Regulation for App Store</h3>
        <p>You can report a problem with any purchase at <a href="http://reportaproblem.apple.com/" target="_blank" rel="noopener noreferrer" style={{color:"#aaaadd"}}>reportaproblem.apple.com</a>. If technical problems prevent delivery of the Game, your sole remedy is either replacement of the Game or a refund of the price paid, as determined by Apple. See <a href="https://support.apple.com/" target="_blank" rel="noopener noreferrer" style={{color:"#aaaadd"}}>support.apple.com</a> for more information.</p>

        <h2>Rights to Content</h2>
        <p>"Content" refers to all software, communications, images, sounds, audio-visual effects, accounts, Virtual Currency and Virtual Items, and material produced by Sasin Software Development and/or received while playing the Games. Unless otherwise expressly stated, all Content is owned, controlled, and/or licensed by Sasin Software Development.</p>
        <p>You are not permitted to copy, redistribute, publish, create derivative works from, or otherwise exploit our Content in violation of Sasin Software Development's intellectual property rights. Sasin Software Development's logos, game titles, and all related characters and elements are trademarks of Sasin Software Development and may not be used without prior written consent.</p>

        <h2>Use of Software</h2>
        <p>All software available for download is the copyrighted work of Sasin Software Development. You may not copy, modify, decompile, disassemble, or reverse engineer the software except as expressly authorized. The software is supplied "AS IS" and you assume the entire risk of using it.</p>
        <p>Sasin Software Development grants you a non-exclusive, non-transferable, revocable, and limited license to use our software solely for its intended purpose. Any illegal use of our software is solely your responsibility.</p>

        <h2>Minors</h2>
        <p>You must be at least 16 years old to access and/or use our website or Games. If you are a minor over the age of 16, we recommend seeking consent from a parent or legal guardian before accessing our website or Games.</p>

        <h2>Termination</h2>
        <p>We reserve the right to terminate your account and prohibit you from using the Service at any time if we reasonably believe you have violated these Terms. Upon termination, you will have no further access to your account or any Content associated with it, and no refunds will be issued for Virtual Currency or Virtual Items.</p>

        <h2>Applicable Law</h2>
        <p>These Terms of Use and all disputes relating to them shall be governed by and construed in accordance with the laws of the United States.</p>

        <h2>Severability</h2>
        <p>If any part of these Terms is found to be invalid or unenforceable under applicable law, it shall be severed from these Terms to the extent of its invalidity, and the remaining Terms shall remain in full force and effect.</p>

        <h2>Supplemental Policies</h2>
        <p>Additional policies related to specific services may be issued by Sasin Software Development. Your right to use such services is subject to those pertinent policies and these Terms of Use.</p>

        <p style={{marginTop:"2rem", paddingTop:"1rem", borderTop:"1px solid #2a2a50"}}>YOU AGREE THAT YOUR USE OF THE INFORMATION, CONTENT, OR SERVICES ACKNOWLEDGES THAT YOU HAVE READ THIS AGREEMENT, UNDERSTAND IT, AND AGREE TO BE BOUND BY ITS TERMS AND CONDITIONS.</p>
        <p>If you have any questions or comments, please contact us at <a href="mailto:sasinandrei@gmail.com" style={{color:"#aaaadd"}}>sasinandrei@gmail.com</a>.</p>
      </div>
    </div>
  );
}

function ContactUs() {
  return (
    <div className="page">
      <h1 className="section-title">Contact Us</h1>
      <p className="section-subtitle">Get in touch with us</p>
      <div className="contact-card">
        <h2>Sasin Software Development</h2>
        <p>
          No 315, Monivong Blvd.<br />
          Office 1849 Register 05,<br />
          Phnom Penh,<br />
          Cambodia
        </p>
      </div>
    </div>
  );
}

const PAGES = [
  { id: "games",   label: "Our Games" },
  { id: "terms",   label: "Terms of Use" },
  { id: "privacy", label: "Privacy Policy" },
  { id: "contact", label: "Contact Us" },
];

export default function App() {
  const [page, setPage] = useState("games");

  return (
    <>
      <style>{styles}</style>
      <nav>
        <div className="nav-logo" onClick={() => setPage("games")}>
          Sasin Software Development
        </div>
        <ul className="nav-links">
          {PAGES.map(p => (
            <li key={p.id}>
              <button
                className={page === p.id ? "active" : ""}
                onClick={() => setPage(p.id)}
              >
                {p.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {page === "games"   && <OurGames />}
      {page === "privacy" && <PrivacyPolicy />}
      {page === "terms"   && <TermsOfUse />}
      {page === "contact" && <ContactUs />}

      <footer>© 2025 Sasin Software Development · All rights reserved</footer>
    </>
  );
}